import { Link, MenuItem, Typography } from "@mui/material";
import type { JSX } from "react";
import { Link as RouterLink } from "react-router";

export const ActionMenuItemLink = (props: {
  icon: JSX.Element;
  title: string;
  disabled?: boolean;
  href: string;
  openInNewTab?: boolean;
  onClick: () => void;
}) => {
  const { icon, title, disabled, href, openInNewTab, onClick } = props;

  return (
    <MenuItem onClick={onClick} sx={{ p: 0 }} disabled={disabled}>
      <Link
        component={RouterLink}
        to={href}
        target={openInNewTab ? "_blank" : undefined}
        underline="none"
        sx={{ color: "secondary.main", px: 2, py: 0.75, display: "flex", width: "100%" }}
      >
        {icon}
        <Typography sx={{ pl: 1 }} color="textPrimary">
          {title}
        </Typography>
      </Link>
    </MenuItem>
  );
};

export default ActionMenuItemLink;
